export default __webpack_public_path__ + "static/media/git.98e5314b.png";